/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Edit_ArticleInputs */

const en_page_title_edit_article = /** @type {(inputs: Page_Title_Edit_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit article`)
};

const nl_page_title_edit_article = /** @type {(inputs: Page_Title_Edit_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel bewerken`)
};

/**
* | output |
* | --- |
* | "Edit article" |
*
* @param {Page_Title_Edit_ArticleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_edit_article = /** @type {((inputs?: Page_Title_Edit_ArticleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Edit_ArticleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_edit_article(inputs)
	return en_page_title_edit_article(inputs)
});